import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createRoute, lazyRouteComponent, useNavigate } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { useSession } from '@/session'
import { ACTIONS, AUDIT_KINDS, AUDIT_SORTABLE } from '../vocabulary'
import { AuditList } from './components/List'
import { entriesQuery, entryQuery } from './queries'

const auditSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, AUDIT_SORTABLE, [], ['subject_id'], {
    kind: AUDIT_KINDS,
    action: ACTIONS,
  })

export const auditRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('audit'),
  path: '/audit',
  validateSearch: auditSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(entriesQuery(deps))),
  component: AuditPage,
})

function AuditPage() {
  const query = auditRoute.useSearch()
  const navigate = useNavigate({ from: auditRoute.fullPath })
  const { locale } = useSession()
  const { data: page } = useSuspenseQuery(entriesQuery(query))

  return (
    <AuditList
      page={page}
      query={query}
      locale={locale}
      onQuery={(patch) => navigate({ search: (prev) => ({ ...prev, ...patch }) })}
      onReset={() => navigate({ search: {} })}
    />
  )
}

export const auditEntryRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('audit'),
  path: '/audit/$id',
  validateSearch: auditSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(entryQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'AuditEntryPage'),
})

export const auditRoutes = [auditRoute, auditEntryRoute]
